import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { MaskedLines } from "../components/Reveal";

export default function Jobs() {
  const mount = useRef(null);

  useEffect(() => {
    const host = mount.current;
    const s = document.createElement("script");
    s.id = "compas-jobs-widget";
    s.type = "text/javascript";
    s.src = "https://hire.myavionte.com/app/careers/dist/jobs.js";
    s.setAttribute("data-bid", "IWH3WN5_7x0");
    s.setAttribute("data-jbid", "_upm-qvIO4c");
    host.appendChild(s);
    return () => { host.innerHTML = ""; };
  }, []);

  return (
    <div data-testid="jobs-page" className="relative pt-[72px]">
      <section className="mx-auto max-w-[1500px] px-6 md:px-10 pt-16 md:pt-24 pb-10 grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
        <div className="lg:col-span-8">
          <p className="overline text-flame mb-6">Job Seekers · Job Board</p>
          <h1 className="font-display uppercase tracking-tighter leading-[0.85] text-[11vw] lg:text-[6vw]">
            <MaskedLines lines={["Jobs available", <span key="2" className="text-cobalt">right now.</span>]} delay={0.2} />
          </h1>
        </div>
        <div className="lg:col-span-4">
          <p className="text-muted-foreground text-lg">New openings are posted regularly — check back often. Don't see the right fit? Submit a general application and we'll match you when something opens up.</p>
          <Link to="/apply" data-testid="jobs-general-apply-btn" className="inline-flex items-center gap-2 mt-6 bg-cobalt text-white px-6 py-3 rounded-full overline hover:bg-flame transition-colors duration-300">
            General application <ArrowUpRight size={14} />
          </Link>
        </div>
      </section>
      <section className="mx-auto max-w-[1500px] px-6 md:px-10 pb-28">
        <div ref={mount} data-testid="jobs-widget-container" className="min-h-[600px] border-t border-border pt-8 [&_iframe]:w-full [&_iframe]:min-h-[600px] [&_iframe]:border-0" />
      </section>
    </div>
  );
}
